export const SOAR_RANKING_ID = 19723756;
export const NEWSONG_RANKING_ID = 3779629;
export const ORIGINAL_RANKING_ID = 2884035;
